import { NgModule } from '@angular/core';

import { HisInputPersonalAgreementSharedModule } from './his-input-personal-agreement-shared.module';

/**
 * The core module for the generic search.
 */
@NgModule( {
    imports: [
        HisInputPersonalAgreementSharedModule
    ],
    declarations: [
    ],
    exports: [
        HisInputPersonalAgreementSharedModule
    ]
} )

export class HisInputPersonalAgreementCoreModule {

}
